// extracted by mini-css-extract-plugin
module.exports = {"container":"_38815c1","header":"_65dcb31","gameList":"_422d0dd"};